module.exports = __webpack_public_path__ + "assets/img/s3.74be2a2a.png";